import React from "react"
import Layout from "../../../components/layout"
import Seo from "../../../components/seo"
import { injectIntl } from "gatsby-plugin-react-intl"
import HeroSubpage from "../../../components/heroes/hero-subpage"
import ClientsTicker from "../../../components/misc/clients-ticker"
import DemoTrial from "../../../components/ctas/demo-trial"

const MailingErrorPage = ({ intl, location }) => (
  <Layout>
    <Seo lang={intl.locale} title={intl.formatMessage({id : "pages.mailing.error.title"})} description={intl.formatMessage({id : "pages.mailing.error.description"})} pathname={location.pathname} />
    <HeroSubpage theme={`primary`} content={{title: intl.formatMessage({id : "pages.mailing.error.title"}), text: intl.formatMessage({id : "pages.mailing.error.description"})}} />
    <ClientsTicker content={{title: intl.formatMessage({ id: "pages.mailing.error.ticker.title" })}}/>
    {/*<DemoTrial />*/}
  </Layout>
)

export default injectIntl(MailingErrorPage)
